"use client";

import { useEffect, useRef, useState } from "react";
import { TrendingUp, Users, Award, Target } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Statistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const stats = [{
    icon: TrendingUp,
    value: 500,
    suffix: "+",
    label: "Cases Resolved"
  }, {
    icon: Users,
    value: 95,
    suffix: "%",
    label: "Satisfaction Rate"
  }, {
    icon: Award,
    value: 15,
    suffix: "+",
    label: "Years Experience"
  }, {
    icon: Target,
    value: 300,
    suffix: "+",
    label: "Trusted Clients"
  }];
  return <section id="statistics" className="dark bg-background text-foreground py-20 px-4" ref={ref}>
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => <StatCard key={i} data-index={i} icon={stat.icon} value={stat.value} suffix={stat.suffix} label={stat.label} isVisible={isVisible} delay={i * 100} />)}
        </div>
      </div>
    </section>;
}
function StatCard({
  icon: Icon,
  value,
  suffix,
  label,
  isVisible,
  delay,
  ...props
}: {
  icon: any;
  value: number;
  suffix: string;
  label: string;
  isVisible: boolean;
  delay: number;
  [key: string]: any;
}) {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);
  useEffect(() => {
    if (isVisible && !hasAnimated.current) {
      hasAnimated.current = true;
      const timeout = setTimeout(() => {
        const duration = 2000;
        const steps = 60;
        const increment = value / steps;
        let current = 0;
        const timer = setInterval(() => {
          current += increment;
          if (current >= value) {
            setCount(value);
            clearInterval(timer);
          } else {
            setCount(Math.floor(current));
          }
        }, duration / steps);
        return () => clearInterval(timer);
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [isVisible, value, delay]);
  return <div className="flex flex-col items-center text-center gap-4 opacity-0 translate-y-8 transition-all duration-500 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" data-visible={isVisible} style={{
    transitionDelay: `${delay}ms`
  }} {...props}>
      <div className="text-primary">
        <Icon size={64} strokeWidth={1.5} />
      </div>

      <div className="font-extrabold text-5xl text-foreground leading-none">
        {count}
        {suffix}
      </div>

      <div className="text-muted-foreground text-lg font-medium">
        {label}
      </div>
    </div>;
}